import React, { useState } from 'react';
import logger from '../utils/logger';
import './QuizQuestion.css';

const QuizQuestion = ({ question, choices, selectedChoices, onAnswer, onSubmit }) => {
  const [currentSelection, setCurrentSelection] = useState(selectedChoices || []);

  const handleChoiceClick = (choiceId) => {
    let newSelection;
    if (question.questionType === 'single') {
      // Single choice: replace selection
      newSelection = [choiceId];
    } else {
      // Multiple choice: toggle selection
      if (currentSelection.includes(choiceId)) {
        newSelection = currentSelection.filter(id => id !== choiceId);
      } else {
        newSelection = [...currentSelection, choiceId];
      }
    }
    
    setCurrentSelection(newSelection);
    
    logger.userAction('select_choice', {
      questionId: question.id,
      choiceId,
      questionType: question.questionType,
      currentSelection: newSelection
    });
  };

  const handleSubmit = () => {
    if (currentSelection.length === 0) {
      logger.userAction('submit_attempt_no_selection', {
        questionId: question.id
      });
      return;
    }

    logger.userAction('submit_answer', {
      questionId: question.id,
      selectedChoices: currentSelection,
      questionType: question.questionType
    });

    onSubmit(currentSelection);
  };

  return (
    <div className="quiz-question">
      <div className="question-content">
        <h3 className="question-text">{question.questionText}</h3>
        
        {question.questionImageUrl && (
          <img 
            src={question.questionImageUrl} 
            alt="Question" 
            className="question-image"
          />
        )}
        
        {question.tags && question.tags.length > 0 && (
          <div className="question-tags">
            {question.tags.map((tag, index) => (
              <span key={index} className="tag">{tag}</span>
            ))}
          </div>
        )}
      </div>

      <div className="choices-container">
        <p className="choice-instruction">
          {question.questionType === 'single' ? 
            '1つ選択してください:' : 
            '該当するものをすべて選択してください:'
          }
        </p>
        
        <div className="choices">
          {choices.map((choice) => (
            <div
              key={choice.id}
              className={`choice ${currentSelection.includes(choice.id) ? 'selected' : ''}`}
              onClick={() => handleChoiceClick(choice.id)}
            >
              <div className="choice-marker">
                {question.questionType === 'single' ? (
                  <div className={`radio ${currentSelection.includes(choice.id) ? 'checked' : ''}`} />
                ) : (
                  <div className={`checkbox ${currentSelection.includes(choice.id) ? 'checked' : ''}`}>
                    {currentSelection.includes(choice.id) && <span className="checkmark">✓</span>}
                  </div>
                )}
              </div>
              
              <div className="choice-content">
                <span className="choice-text">{choice.text}</span>
                {choice.choiceImageUrl && (
                  <img 
                    src={choice.choiceImageUrl} 
                    alt={`Choice ${choice.id}`} 
                    className="choice-image"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
        
        <div className="submit-section">
          <button 
            className={`submit-btn ${currentSelection.length === 0 ? 'disabled' : ''}`}
            onClick={handleSubmit}
            disabled={currentSelection.length === 0}
          >
            回答する
          </button>
          
          {currentSelection.length === 0 && (
            <p className="selection-hint">
              {question.questionType === 'single' ? 
                '選択肢を1つ選んでください' : 
                '選択肢を選んでください'
              }
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuizQuestion;